var map = {
	"./air-berlin.svg": 100,
	"./air-canada.svg": 101,
	"./cae.svg": 102,
	"./h.svg": 103,
	"./norwegian.svg": 104,
	"./novair.svg": 105,
	"./pelesys.png": 106,
	"./raddison.svg": 107,
	"./ryanair.svg": 108,
	"./sas.svg": 109,
	"./skistar.svg": 110,
	"./tui.svg": 111,
	"./wax.svg": 112
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 321;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients ^\.\/.*$
// module id = 321
// module chunks = 3